/* ABB 16 Oct 2026: discount-code gift guard (extends assets/cart-drawer.js, does not replace it).
   cart-drawer.js only ran syncGiftsWithCustomerPromo() after in-drawer cart updates, so a code applied via
   /discount/CODE (incl. snippets/ryze-cart-b-code.liquid) left gift lines in the cart on the next page load.
   This file: (1) runs the existing guard on page load / bfcache restore / tab refocus, (2) also treats lines
   whose product is tagged free-gift as gift lines while a customer code is applied, (3) shows the note
   "Free gifts can't be added while a discount code is applied." Gifts are untouched when no code is applied.
   Rollback: remove the <script> tag for this file from snippets/cart-drawer.liquid. */
(function () {
  if (window.__abbCodeGiftGuard) return;
  window.__abbCodeGiftGuard = true;
  var NOTE = "Free gifts can't be added while a discount code is applied.";
  var TAG_RE = /^free[- ]?gift$/i;
  var tagCache = {};

  function productTags(handle) {
    if (!handle) return Promise.resolve([]);
    if (!tagCache[handle]) {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
      tagCache[handle] = fetch(root + "products/" + encodeURIComponent(handle) + ".js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { return (p && p.tags) || []; })
        .catch(function () { return []; });
    }
    return tagCache[handle];
  }

  function patch(proto) {
    if (proto.__abbCodeGuardPatched) return;
    proto.__abbCodeGuardPatched = true;

    var origIsGift = proto.isPromoRemovableGiftLine;
    proto.isPromoRemovableGiftLine = function (item) {
      return (origIsGift ? origIsGift.call(this, item) : String(item && item.properties && item.properties._gift) === "true") ||
        !!(item && item.__abbTaggedGift);
    };

    // Mark free-gift-tagged lines, only when a customer code is on the cart (no extra requests otherwise).
    var origFetchCart = proto.fetchCartJs;
    proto.fetchCartJs = async function () {
      var cart = await origFetchCart.apply(this, arguments);
      try {
        if (cart && Array.isArray(cart.items) && this.cartHasCustomerPromo && this.cartHasCustomerPromo(cart)) {
          await Promise.all(cart.items.map(function (item) {
            return productTags(item.handle).then(function (tags) {
              if (tags.some(function (t) { return TAG_RE.test(String(t).trim()); })) item.__abbTaggedGift = true;
            });
          }));
        }
      } catch (e) { console.warn("abb code gift guard: tag check failed", e); }
      return cart;
    };

    var origNote = proto.setGiftPromoCartNote;
    if (origNote) {
      proto.setGiftPromoCartNote = function (blocked, code) {
        origNote.apply(this, arguments);
        if (!blocked) return;
        var note = this.querySelector("[data-gift-promo-cart-note]");
        if (note) note.textContent = NOTE + " Remove the code to claim your free gifts.";
      };
    }

    // If gifts were removed while the main /cart page is showing, reload it once so line items/totals match.
    var origRemove = proto.removeAllGiftItems;
    proto.removeAllGiftItems = async function (cart) {
      var result = await origRemove.apply(this, arguments);
      try {
        var removed = result && result !== cart && Array.isArray(result.items) &&
          !result.items.some(this.isPromoRemovableGiftLine.bind(this));
        if (removed && document.querySelector("cart-items") && !sessionStorage.getItem("abbCodeGuardReload")) {
          sessionStorage.setItem("abbCodeGuardReload", "1");
          window.location.reload();
        }
      } catch (e) {}
      return result;
    };
  }

  function run() {
    var drawer = document.querySelector("cart-drawer");
    if (!drawer || typeof drawer.syncGiftsWithCustomerPromo !== "function") return;
    drawer.syncGiftsWithCustomerPromo().catch(function (e) { console.error(e); });
  }

  try { sessionStorage.removeItem("abbCodeGuardReload"); } catch (e) {}
  customElements.whenDefined("cart-drawer").then(function () {
    var Ctor = customElements.get("cart-drawer");
    if (!Ctor) return;
    patch(Ctor.prototype);
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run, { once: true });
    else run();
    window.addEventListener("pageshow", function (e) { if (e.persisted) run(); });
    document.addEventListener("visibilitychange", function () { if (document.visibilityState === "visible") run(); });
  });
})();
